<script setup>
import tr_ILEM from '@/assets/translations/Tr_ILEM.json';
import { computed } from 'vue';
import { getTranslation } from '@/assets/scripts/getTranslation';
import { useRoute } from 'vue-router';

const route = useRoute();
const otpCode = route.query["otpcode"];
const type = route.query["type"];

var showOtpBox = computed(() => {
  return type != "activation-email" && !!otpCode
});

const appleUrl = 'https://apps.apple.com/us/app/i-love-english-5-8/id6499127507';
const googleUrl = 'https://play.google.com/store/apps/details?id=com.groupebayard.iloveenglish';
const amazonUrl = undefined;

</script>
<template>
  <main class="page-layout ilem-bg">

    <!-- Logo -->
    <div class="logo-app mb-4 text-center">
      <img :src="require(`@/assets/img/ILEM/ILoveEnglish_Logo.svg`)" alt="logo  love English mini">
    </div>

    <!-- White box (+ animated kids) -->
    <div class="whitebox gap-4 d-flex flex-column align-items-center">

      <!-- OTP -->
      <div class="whitebox__otpcode" v-if="showOtpBox">
        <div class="whitebox__title">
          {{ getTranslation('title-label', tr_ILEM, $i18n.locale) }}
        </div>
        <div class="whitebox__subtitle">
          <div class="whitebox__otp">
            {{ otpCode }}
          </div>
          {{ getTranslation('subtitle-label', tr_ILEM, $i18n.locale) }}
        </div>
      </div>

      <!-- Default box (no otp) -->
      <div class="whitebox__noapp" v-else>
        <div class="whitebox__title">
          {{ getTranslation('no-otp-title', tr_ILEM, $i18n.locale) }}
        </div>
        <div class="whitebox__subtitle">
          {{ getTranslation('no-otp-subtitle', tr_ILEM, $i18n.locale) }}
        </div>
      </div>

      <!-- Store Buttons -->
      <div class="whitebox__activation d-md-grid d-flex flex-column gap-lg-2 gap-1">
        <a v-if="appleUrl" :href="appleUrl" class="whitebox__activation-apple whitebox__activation-link"
          target="_blank">
          <img src="@/assets/img/AppStore-button.svg" alt="" class="whitebox__activation-img">
        </a>
        <a v-if="googleUrl" :href="googleUrl" target="_blank"
          class="whitebox__activation-google whitebox__activation-link">
          <img src="@/assets/img/GooglePlay-button.svg" alt="" class="whitebox__activation-img">
        </a>
        <a v-if="amazonUrl" :href="amazonUrl" target="_blank"
          class="whitebox__activation-amazon whitebox__activation-link">
          <img src="@/assets/img/Amazon-button.svg" alt="" class="whitebox__activation-img">
        </a>
      </div>

      <div class="whitebox__next" v-if="!otpCode">
        {{ getTranslation('next-label', tr_ILEM, $i18n.locale) }}
      </div>

      <div class="whitebox__contact">
        <a :href="`https://edokiacademy.freshdesk.com/${$i18n.locale}/support/solutions/folders/44001232982`"
          target="_blank">
          {{ getTranslation('contact-label', tr_ILEM, $i18n.locale) }}
        </a>
      </div>

      <div class="whitebox__characters">
        <img src="@/assets/img/ILEM/Abby.gif" alt="" class="whitebox__character whitebox__character--girl">
        <img src="@/assets/img/ILEM/Leo.gif" alt="" class="whitebox__character whitebox__character--boy">
      </div>

    </div>
  </main>
</template>

<style lang="scss" scoped>
.ilem-bg {
  background-image: url(@/assets/img/ILEM/Background.svg);
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  background-color: #5DEEEA;
}

.logo-app {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
}

.whitebox {


  &__title {
    text-align: center;
  }

  &__subtitle {
    margin: 0 auto;
  }

  &__next {
    font-weight: 600;
    font-size: 1.2rem;
    width: 60%;
    text-align: center;
  }

  &__contact {
    text-align: center;
    font-weight: 500;
    font-size: 0.8rem;

    a {
      text-decoration: none;
      cursor: pointer;
      color: #183951;
    }
  }

  &__activation {
    grid-template-columns: auto auto;
    justify-items: center;

    &-apple {
      grid-column: 1/3;
    }

    &-google {
      grid-row: 2;
    }

    &-amazon {
      grid-row: 2;
    }
  }

  &__character {
    width: 20rem;
    position: absolute;
    top: 6rem;

    &--girl {
      left: -15rem;
      transform: translateY(-10px);
    }

    &--boy {
      right: -14rem;
      transform: translateY(-10px);
    }
  }
}

@media (max-width: 992px) {

  .logo {
    img {
      width: 80%;
    }
  }

  .whitebox {
    &__title {
      font-size: 1.7rem;
    }

    &__subtitle {
      font-size: 1rem;
    }

    &__next {
      font-size: 0.8rem;
    }

    &__activation {
      &-link {
        width: 10rem;
      }

      &-img {
        width: inherit;
      }
    }

    &__character {
      width: 16rem;
      top: 7rem;

      &--boy {
        right: -12rem;
        transform: translateY(-30px);
      }

      &--girl {
        left: -13rem;
        transform: translateY(-30px);
      }
    }
  }
}

@media (max-width: 768px) {

  .page-layout {
    background-size: cover;
    padding-bottom: 8rem;
  }

  .logo {
    margin-bottom: 1rem;

    img {
      width: 60%;
    }
  }

  .whitebox {
    gap: 1rem;
    width: 90vw;
    padding: 1.5rem 0 10rem;

    &__character {
      position: absolute;
      top: 25rem;
      width: 11rem;

      &--girl {
        left: -1rem;
      }

      &--boy {
        right: -1rem;
      }
    }
  }
}

@media (max-width: 459px) {

  .page-layout {
    padding-bottom: 9rem;
  }

  .whitebox {
    padding-bottom: 6rem;

    &__character {
      width: 9rem;
      top: auto;
      bottom: -8rem;
    }

    &__title {
      font-size: 1.5rem;
    }

    &__subtitle {
      font-size: 1rem;
    }

    &__next {
      font-size: 1rem;
    }

    &__contact {
      width: 50%;
      font-size: 1rem;
    }
  }
}

@media (min-width: 1441px) {

  .whitebox {
    &__title {
      font-size: 2.5rem;
    }

    &__subtitle {
      font-size: 1.5rem;
    }

    &__next {
      font-size: 1.2rem;
    }

    &__contact {
      font-size: 1rem;
    }

    &__character {
      width: 25rem;
      top: 3rem;

      &--girl {
        left: -19rem;
        top: 4rem;
      }

      &--boy {
        right: -19rem;
      }
    }
  }
}
</style>